import request from '@/router/axios';

// 手术申请
export const surgerySave = (data) => request({
  url: '/api/blade-consult/operation/apply/save',
  method: 'post',
  data
})
// 向我申请列表
export const surgeryList = (pageNumber,pageSize) => request({
  url: '/api/blade-consult/operation/apply/list',
  method: 'get',
  params:{
    current:pageNumber,
    size:pageSize
  }
})
